import { styled } from '@a1s/ui';

export const StyledSVG = styled('svg', {
  height: '1em',
  display: 'block',
  width: '1em',
});
